import { EventType } from "@/global/store/data/types";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import NextImage from "next/image";
import { blurDataURL } from "@/global/common/blur-data-url";
import { Divider } from "@/shared/base/components/Divider/Divider";
import { convertDate } from "@/global/utils/dateTimeConvert";
import { convertTime } from "@/global/utils/dateTimeConvert";
import { MarqueeTextV2 } from "../layouts/MarqueeText/MarqueeTextV2";

export function BasicEventCard(props: { event: EventType }) {
  const theme = useTheme();

  return (
    <Stack
      height={"100%"}
      sx={{
        border: `1px solid  ${theme.palette.divider}`,
        borderRadius: "8px",
      }}
    >
      <Box p={2} py={1.5}>
        <Stack
          direction={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          spacing={2}
        >
          <Box width="48px" height={"48px"}>
            {props?.event?.logoUrl ? (
              <NextImage
                src={props?.event?.logoUrl}
                alt={"StadiumBackground team logo"}
                width={48}
                height={48}
                style={{ objectFit: "contain", borderRadius: "4px" }}
                loading="lazy"
                placeholder="blur"
                blurDataURL={blurDataURL}
              />
            ) : null}
          </Box>

          <Box textAlign={"left"} width={"100%"}>
            <MarqueeTextV2>
              <Typography fontSize={"1rem"} fontWeight={700}>
                {props?.event?.title}
              </Typography>
            </MarqueeTextV2>
          </Box>
        </Stack>
      </Box>
      <Divider />
      <Box padding={"1rem"} flexGrow={1}>
        <Stack direction={"column"} height="100%">
          <MarqueeTextV2>
            <Typography
              variant="body1"
              color="text.secondary"
              fontSize={"0.9rem"}
              fontWeight={"500"}
            >
              {convertDate(props?.event?.date)} |{" "}
              {convertTime(props?.event?.time)}
            </Typography>
          </MarqueeTextV2>
        </Stack>
      </Box>
    </Stack>
  );
}
